import { isObject, isString } from "../utils";
import WarningIcon from "../images/icons/warning.png" 
import { broadcaster } from "../utils/events";
import { Popup } from "./popups";
import { InfoText, objToEl } from "./misc";


function exceptionsElementsList(ex){
    let errors = [];

    if(isString(ex) && (ex[0] === "[" || ex[0] === "{")){
        try{
            ex = JSON.parse(ex);
        } catch(e){}
    }

    if(isObject(ex)){
        for(let [k, v] of Object.entries(ex)){
            if(isString(v)){errors.push((v.length < 20 ? `${k}: `: "") + v);}
            else {
                errors.push(<div className="tw-pl-2 tw">{k} <InfoText text={objToEl(v)} /></div>);
            }
        }
    }

    else if(Array.isArray(ex)){
        for(let v of ex){
            errors = errors.concat(exceptionsElementsList(v));
        }
    }
    else {
        errors.push(ex + "");
    }
    return errors;
}

function GenericException({ex}){
    if(!ex) return null;
    if(ex.isAxiosError && ex.response){
        ex = ex.response.data;
        delete ex.errors?.schema; // as this is a bit too much
    }

    let errors = exceptionsElementsList(ex);
    
    return errors.length === 0 ? null : (
        <div className="tw-rounded-xl tw-bg-red-200 tw-px-4 tw-py-2 tw-my-2 tw-flex tw-items-center tw-gap-2">
            <div className='w3-padding-8-4'>
                <img src={WarningIcon} width="16px" />
            </div>
            <div className='tw-text-sm '>
                {
                    errors.map(
                        (v, i) => isString(v) 
                            ? <div key={i} className="" dangerouslySetInnerHTML={{ __html: v }} /> 
                            : v
                    )
                }
            </div>
        </div>
    );
}

GenericException.showPopup = function(ex, title){
    let popup;
    if(ex && ex.need_user){
        if(broadcaster.broadcast_event("error:need_user")){
            return; // handled
        }
    }
    popup = Popup.show(
        title || "Sorry! Error occured",
        <GenericException ex={ex} />
    )
    return popup;
}

export {GenericException}
